export enum TipoPagamentoEnum {
  TUTTI = 'Tutti',
  IN_ATTESA = 'In Attesa',
  PAGATI = 'Pagati'
}
